import { Icon, TEventrIcons } from "@eventr/common-storybook";
import { ICategory } from "@eventr/common/lib/dto/mt/categories/categories";
import { Stack } from "@mui/material";
import { useMemo } from "react";
import { getCategoryColours } from "utils";
import { useFormatValue } from "../../hooks/useFormatValue";
import { useObjectContext } from "../providers/objectProvider";
import { CardText } from "../subComponents/cardText";
import { ColouredIcon } from "../subComponents/colouredIcon";
interface IFlightDateProps {
  date: string;
  label: string;
  flightNumber?: string;
  visibility?: string;
  category?: ICategory | undefined;
}
export const FlightDate = ({ date, label, flightNumber, visibility, category }: IFlightDateProps) => {
  const { formatValue } = useFormatValue();
  const { past } = useObjectContext();
  const icon = useMemo(() => {
    if (label?.includes("Arrive")) {
      return "Arrive";
    } else if (label?.includes("Depart")) {
      return "Depart";
    } else {
      return "Flight";
    }
  }, [label]);
  const iconColour = getCategoryColours(past, category);
  return (
    <Stack direction="row" sx={{
      justifyContent: "space-between"
    }}>
      <Stack direction="row" sx={{
        gap: "8px"
      }}>
        <Icon name={category?.icon as TEventrIcons ?? icon} iconColour={iconColour} />
        <CardText variant="bodyBold">{formatValue(date, "date")}</CardText>
      </Stack>
      {flightNumber && (
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "8px"
          }}>
          {visibility?.toLowerCase() === "private" ? (
            <ColouredIcon height="16px" name="Private" />
          ) : (
            visibility?.toLowerCase() === "public" && <ColouredIcon height="16px" name="Public" />
          )}
          <CardText variant="bodyBold">{flightNumber}</CardText>
        </Stack>
      )}
    </Stack>
  );
};
